/* The standing buy bar.

   One source, two builds: build.py inlines this into the standalone page and
   mkcss.py copies it to theme/assets/swaha-buybar.js. Hooks are data attributes,
   not classes, because the theme stylesheet renames every class.

   It shows once the opening section has scrolled away and hides again over the
   pre-order section, where it would only duplicate the button already on screen,
   and over the footer, which it would otherwise cover — on a wide screen the
   social links sit in the last hundred pixels of the page. */
(function () {
  function init() {
    var bar = document.querySelector('[data-swaha-buybar]');
    if (!bar || bar.dataset.ready === '1') return;
    bar.dataset.ready = '1';

    var hero = document.querySelector('[data-swaha-hero]');
    var buy = document.querySelector('[data-swaha-preorder]');
    var foot = document.querySelector('[data-swaha-foot]');
    var pastHero = false, atBuy = false, atFoot = false;

    function sync() {
      if (pastHero && !atBuy && !atFoot) bar.setAttribute('data-show', '');
      else bar.removeAttribute('data-show');
    }

    /* Without IntersectionObserver the bar simply stays put rather than
       following the scroll — the page still sells, it just doesn't animate. */
    if (!('IntersectionObserver' in window) || !hero) {
      sync();
      return;
    }

    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(hero);

    if (buy) {
      new IntersectionObserver(function (entries) {
        atBuy = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.12 }).observe(buy);
    }

    if (foot) {
      new IntersectionObserver(function (entries) {
        atFoot = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(foot);
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* the theme editor re-renders sections on every edit */
  document.addEventListener('shopify:section:load', init);
})();
